import React, { Component } from "react";

class HomeHeaderMenuPrimary extends Component {
  constructor() {
    super();
    this.state = {
      over: false,
      pushed: false,
    };

    this.scrollEvent = this.scrollEvent.bind(this);
    this.set = this.set.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollEvent, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollEvent, { passive: true });
  }

  removeActive() {
    if (document.querySelector(".active")) {
      let actives = document.querySelector(".active");

      if (actives !== null) {
        actives.classList.remove("active");
      }
    }
  }

  scrollEvent() {
    let offset = 76;
    const offsets = [];
    const link_names = [];

    offsets.push(document.getElementById("services").offsetTop);
    offsets.push(document.getElementById("about-us").offsetTop);
    offsets.push(document.getElementById("testimonials").offsetTop);
    offsets.push(document.getElementById("news").offsetTop);
    offsets.push(document.getElementById("contacts").offsetTop);

    link_names.push(document.getElementById("nav-services"));
    link_names.push(document.getElementById("nav-about"));
    link_names.push(document.getElementById("nav-testimonials"));
    link_names.push(document.getElementById("nav-news"));
    link_names.push(document.getElementById("nav-contacts"));

    if (!this.state.pushed) {
      if (window.scrollY < offsets[0]) {
        this.removeActive();
      }

      for (let i = 0; i < offsets.length; i++) {
        if (window.scrollY + offset > offsets[i]) {
          this.removeActive();
          link_names[i].classList.add("active");
        }
      }
    }
  }

  scrollToSection(e, sectionId) {
    e.preventDefault();
    this.setState({ pushed: true });
    this.removeActive();

    let active = e.currentTarget;
    active.parentNode.classList.add("active");

    const element = document.getElementById(sectionId);
    if (element) {
      const header = document.querySelector("header.site-header");
      const headerHeight = header ? header.offsetHeight : 80;
      const y = element.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
      window.scrollTo({ top: y, behavior: "smooth" });
    }

    setTimeout(this.set, 800);
  }

  set() {
    this.setState({ pushed: false });
  }

  render() {
    return (
      <div className="menu">
        <nav className="menu-primary">
          <ul className="nav">
            <li id="nav-services" className="nav-item">
              <a
                title="Services"
                href="#services"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.scrollToSection(e, "services")}
              >
                Services
              </a>
            </li>

            <li id="nav-about" className="nav-item">
              <a
                title="About Us"
                href="#about-us"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.scrollToSection(e, "about-us")}
              >
                About Us
              </a>
            </li>

            <li id="nav-testimonials" className="nav-item">
              <a
                title="Client Stories"
                href="#testimonials"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.scrollToSection(e, "testimonials")}
              >
                Client Stories
              </a>
            </li>

            <li id="nav-news" className="nav-item">
              <a
                title="Blogs"
                href="#news"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.scrollToSection(e, "news")}
              >
                Blogs
              </a>
            </li>

            <li id="nav-contacts" className="nav-item">
              <a
                title="Contact Us"
                href="#contacts"
                style={{ cursor: "pointer" }}
                onClick={(e) => this.scrollToSection(e, "contacts")}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default HomeHeaderMenuPrimary;
